/**
 * Canonical geometry every kitchen rendering is captured at. Previews must letterbox to
 * RENDERING_CAPTURE_ASPECT and render through the capture path — the live viewport aspect
 * changes with screen and window size, so it can never be the reference for what ships.
 */
export const RENDERING_CAPTURE_WIDTH = 1920;
export const RENDERING_CAPTURE_HEIGHT = 1080;
export const RENDERING_CAPTURE_ASPECT = RENDERING_CAPTURE_WIDTH / RENDERING_CAPTURE_HEIGHT;
